<script lang="ts">
    import BaseButton from "@components/Buttons/BaseButton.svelte";

    import WishlistHeartFilledIcon from "./icons/WishlistHeartFilledIcon.svelte";
    import WishlistHeartOutlinedIcon from "./icons/WishlistHeartOutlinedIcon.svelte";

    let className = "";
    export { className as class };
    export let inWishlist: boolean | undefined;
    export let handleDelete: () => void;
    export let handleAdd: () => void;
</script>

{#if inWishlist}
    <BaseButton class={className} on:click={handleDelete}>
        <WishlistHeartFilledIcon />
    </BaseButton>
{:else}
    <BaseButton class={className} on:click={handleAdd}>
        <WishlistHeartOutlinedIcon />
    </BaseButton>
{/if}

<style lang="postcss">
    :global(.gw-btn:hover .gw-wl-heart-icon path) {
        fill: #ff7a6c;
        stroke: none;
    }
</style>
